import React, {useContext} from 'react';

import logo from "assets/img/logo.png";

import {SidebarContext} from "../../../SidebarContext";

function WishibamLogo(props) {
    const {currentOrganization} = useContext(SidebarContext);

    return (
        <div style={{
            width: '200px',
            margin: '16px auto',
            maxHeight: '40px',
        }}>
            <img
                style={{width: '100%', maxHeight: '40px'}}
                src={currentOrganization?.customLogo ? currentOrganization.customLogo : logo}
                alt='Wishibam'
            />
        </div>
    );
}

export default WishibamLogo;
